/* eslint-disable */
export default {
  showAlert: function(title, message, type) {
    if (process.env['NODE_ENV'] == 'development') {
      console.warn('$alert.showAlert - This function is deprecated. Please use $showAlert instead.');
    }
    Swal.fire({
      type: type,
      title: title,
      text: message
    });
  },
  questionAlert: async function(title, message, confirm, cancel, type, confirmColor, cancelColor) {
    if (process.env['NODE_ENV'] == 'development') {
      console.warn('$alert.questionAlert - This function is deprecated. Please use $showAlert instead.');
    }
    var result = await Swal.fire({
      type: type ? type : 'info',
      title: title,
      text: message,
      confirmButtonText: confirm ? confirm : 'Confirm',
      cancelButtonText: cancel ? cancel : 'Cancel',
      showCancelButton: true,
      confirmButtonColor: confirmColor ? confirmColor : '',
      cancelButtonColor: cancelColor ? cancelColor : ''
    });

    return result;
  }
}

/*
I've made this file as global,
You may call this alert anywhere.
Example for simple alert: 
  this.$alert.showAlert('Your title here', 'Your message', type);

For the type, you can choose from 'success' or 'error' or 'warning' or 'info'
For different type, it will give you a different icon

Example for question:
  var question = await this.$alert.questionAlert(parameters_here_refer_top);

The question will return { value: true } if you click the confirm button
*/